import { render, staticRenderFns } from "./leadscoring.vue?vue&type=template&id=b2361204&scoped=true"
import script from "./leadscoring.vue?vue&type=script&lang=js"
export * from "./leadscoring.vue?vue&type=script&lang=js"
import style0 from "./leadscoring.vue?vue&type=style&index=0&id=b2361204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2361204",
  null
  
)

export default component.exports